export default function CloseIcon() {
  return (
      <svg width="14" height="15" viewBox="0 0 14 15" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M1.5 2L12.5 13M12.5 2L1.5 13" stroke="#002532" strokeWidth="0.58" strokeLinecap="round" strokeLinejoin="round"/>
      </svg>
  );
}